export const updateTest = (payload?: any) => ({
    type: "@saga/UPDATE_TEST",
    payload
});

